import React from "react";
import aboutImg from "../assets/about.jpeg";

const AboutSection = () => (
  <div className="about-section">
    <img src={aboutImg} alt="Photographer" className="about-img" />
    <div className="bio">
      <h2>Abhimanyu Pathak</h2>
      <h4>Photographer | Visual Storyteller | Mumbai</h4>
      <p>
        Based in Mumbai, I specialize in capturing the essence of large-scale
        events, international exhibitions and keen in learning new skills with
        interest in fashion photography. With over two years of experience in
        high-pressure production environments, I bring a balance of technical
        precision and creative storytelling to every project.
      </p>
      <p>
        My work focuses on delivering clean, impactful imagery that reflects
        both scale and detail—whether it's the dynamic energy of global trade
        fairs or the subtle, candid moments that often go unnoticed. I aim to
        bridge the gap between corporate documentation and artistic expression,
        creating visuals that are both purposeful and evocative.
      </p>
      <p>
        From covering high-profile events such as the WAVES Summit, Raisina
        Dialogue and Startup Mahakumbh to documenting international exhibitions,
        I am dedicated to showcasing the innovation, atmosphere, and human
        element of the modern professional world.
      </p>
      <p>
        Alongside large-scale productions, I explore atmospheric and
        vintage-inspired portraiture, adding depth and versatility to my visual
        narrative.
      </p>
      <p>
        <strong>Equipment of Choice:</strong> Canon R6 Mark II, Sony Alpha 7 IV
      </p>
    </div>
  </div>
);

export default AboutSection;
